
export class CategoryPrescription {
    constructor(
        public id: number,
        public nom: string,
        public chapitre: string
    ) {}
}
